export const Category = {
  B2B2C: "B2B2C",
  B2C: "B2C"
};
